import {cmps} from './constantes';

export const esquemaCampos = {
   [cmps.PRODUCTOS]: {valor: null, error: ''},
   [cmps.VERSION]: {valor: null, error: ''},
   [cmps.PRESENTACION]: {valor: null, error: ''},
   [cmps.URL]: {valor: '', error: ''},
   [cmps.TIENDA]: {valor: null, error: ''}
};

export const esquemaValidacion = {
   [cmps.PRODUCTOS]: {
      requerido: true
   },
   [cmps.VERSION]: {
      requerido: true
   },
   [cmps.PRESENTACION]: {
      requerido: true
   },
   [cmps.URL]: {
      requerido: true
   },
   [cmps.TIENDA]: {
      requerido: false
   }
};
